import React from "react";
import { PageLayout, Image, ContactForm } from "@bluefin/components";
import { Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";

export default class EmploymentPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness } = data;

    return (
      <WebsiteLayout>
        <PageLayout hero={null}>
          <Image
            src={
              "https://fisherman.gumlet.io/public/f5800c80-941a-45de-9267-7716e178c9d2/2_cJVQOaf.png"
            }
            className={"page-background-image"}
            background={true}
          >
            <div />
          </Image>
          <Grid
            stackable={true}
            className={"menu-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={"12"} textAlign={"center"}>
              <p className={"large-text"}>
                Our team is passionate, hard-working, and dedicated to providing
                excellent customer service. If you share our passion, then we'd
                love to hear from you!
              </p>
            </Grid.Column>
            <Grid.Column width={"16"} textAlign={"left"}>
              <ContactForm
                constructMessage={({
                  name,
                  email,
                  phone,
                  address,
                  birthdate,
                  workExperience,
                  phoneNumberEmployer,
                  reasonOfLeaving,
                  dateFirstAVailable,
                  hoursAVailable,
                  daysAVailable,
                }) =>
                  `Someone has reached out to you via your website hiring form: Name: ${name}, Email: ${email}, Phone: ${phone}, Address: ${address}, Birthdate: ${birthdate}, Work Experience: ${workExperience}, Phone Number Employer: ${phoneNumberEmployer}, Reason Of Leaving Employer: ${reasonOfLeaving}, Date First Available: ${dateFirstAVailable}, Hours Available: ${hoursAVailable}, Days Available: ${daysAVailable}`
                }
                fields={[
                  {
                    label: "name",
                    placeholder: "Full Name",
                    type: "input",
                    required: true,
                  },
                  {
                    label: "email",
                    placeholder: "Email",
                    type: "input",
                    inputType: "email",
                    required: true,
                  },
                  {
                    label: "phone",
                    placeholder: "Phone Number",
                    type: "input",
                    required: true,
                  },
                  {
                    label: "address",
                    placeholder: "Address",
                    type: "input",
                    required: true,
                  },
                  {
                    label: "birthdate",
                    placeholder: "Birthdate",
                    type: "input",
                    inputType: "date",
                    required: true,
                  },
                  {
                    displayLabel: "Previous Work Experience",
                    label: "workExperience",
                    placeholder: "Previous Work Experience",
                    type: "input",
                    required: true,
                  },
                  {
                    displayLabel: "Phone number of current or last employer",
                    label: "phoneNumberEmployer",
                    placeholder: "Phone number of current or last employer",
                    type: "input",
                    required: true,
                  },
                  {
                    displayLabel: "Reason for leaving previous employer",
                    label: "reasonOfLeaving",
                    placeholder: "Reason for leaving previous employer",
                    type: "textarea",
                    required: true,
                  },
                  {
                    label: "dateFirstAVailable",
                    displayLabel: "Date first available",
                    placeholder: "Date first available",
                    type: "input",
                    inputType: "date",
                    required: true,
                  },
                  {
                    label: "hoursAvailable",
                    displayLabel: "Hours Available",
                    type: "select",
                    required: true,
                    options: [
                      { label: "AM Shifts", value: "AM Shifts" },
                      { label: "PM Shifts", value: "PM Shifts" },
                      { label: "No preference", value: "No Preference" },
                    ],
                  },
                  {
                    label: "daysAvailable",
                    placeholder: "Days Available",
                    type: "multiSelect",
                    required: true,
                    options: [
                      { label: "Monday", value: "Monday" },
                      { label: "Tuesday", value: "Tuesday" },
                      { label: "Wednesday", value: "Wednesday" },
                      { label: "Thursday", value: "Thursday" },
                      { label: "Friday", value: "Friday" },
                      { label: "Saturday", value: "Saturday" },
                      { label: "Sunday", value: "Sunday" },
                    ],
                  },
                ]}
                buttonText={"Send"}
                centeredHeaders={true}
                className={""}
                fluidButton={true}
                header={""}
                inline={false}
                showLabels={true}
                subheader={""}
                termsCopy={""}
                withContainer={true}
                locationId={fishermanBusiness.primaryLocation._id}
                businessId={fishermanBusiness._id}
                businessType={fishermanBusiness.type}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      primaryLocation {
        _id
      }
      _id
      type
    }
  }
`;
